import { actions } from './actions'

const currentSite = (state = { other_name: '', code: '' }, action) => {
  switch (action.type) {
    case actions.set:
      return action.site
    case actions.resetCurrentSite:
      return { other_name: '', code: '' }
    default:
      return state
  }
}

export default currentSite



// WEBPACK FOOTER //
// ./src/store/current-site/reducer.js